export default __webpack_public_path__ + "static/media/Hair_10_M_C1.f4f0e1e3.svg";